import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'

import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet'

import { Heading } from '@peracto/peracto-ui'
import { CREATE, useClient, getSchemaFromResource } from '@peracto/client'

import { MODE_ADD } from '../AttributeGroupForm'

const AttributeGroupAdd = ({ AttributeGroupForm }) => {
    const { client, getResource } = useClient()
    const [redirect, setRedirect] = useState()

    const schema = getSchemaFromResource(getResource('attribute-groups'))

    const onSubmit = async (data, actions) => {
        const formData = {
            ...data,
            attributes: data.attributes.map(attr => attr['@id']),
        }

        try {
            const response = await client(CREATE, 'attribute-groups', {
                id: 'attribute-groups',
                data: formData,
            })

            if (response.data.violations && response.data.violations.length > 0) {
                // Display errors for invalid fields
                actions.resetForm(data)
                actions.setSubmitting(false)
                response.data.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            } else {
                setRedirect(response.data.id)
                toast.success('Attribute Group successfully added!')
                actions.setSubmitting(false)
            }
        } catch (e) {
            console.error(e)
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )

            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                e.error.body.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            }

            actions.setSubmitting(false)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <>
            <Helmet>
                <title>Attribute Groups | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Attribute Group">
                    <div className="!grow !flex !items-center !justify-end">
                        <Link
                            className="btn btn-outline-primary"
                            to="/attribute-groups"
                            data-testid="back-to-attribute-groups"
                        >
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                            Back to Attribute Groups
                        </Link>
                    </div>
                </Heading>
                <AttributeGroupForm onSubmit={onSubmit} mode={MODE_ADD} schema={schema} />
            </div>
        </>
    )
}

export default AttributeGroupAdd
